import { enqueueSnackbar } from "notistack";

// A saved card's webhook is late (a cold worker on staging takes a minute):
// the card buttons are back, a reload shows it once it lands.
export const notifyCardCheckLate = () =>
  enqueueSnackbar(
    "Your card is still being confirmed. Refresh the page in a minute to see it.",
    { variant: "info" },
  );
